import React, { lazy, Suspense } from "react";
import "./App.css";
import {
  BrowserRouter,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";

// Componentes que se cargan siempre (Navbar, Footer)
import Navbar from "./pages/components/navbar";
import Footer from "./pages/components/footer";

// Página principal se carga inmediatamente
import Index from "./pages/index";

// Lazy loading para todas las demás páginas
const QuienesSomos = lazy(() => import("./pages/nosotros/quienes-somos"));
const ResenaHistorica = lazy(() => import("./pages/nosotros/resena-historica"));
const Cosede = lazy(() => import("./pages/nosotros/cosede"));
const InformacionFinanciera = lazy(() => import("./pages/nosotros/informacion-financiera"));
const Agencias = lazy(() => import("./pages/nosotros/Agencias"));
const GobiernoCorporativo = lazy(() => import("./pages/nosotros/gobierno-coporativo"));
const CodigoEtica = lazy(() => import("./pages/nosotros/codigo-etica"));
const Indicadoresgenero = lazy(() => import("./pages/nosotros/Indicadoresgeneros"));
const Saras = lazy(() => import("./pages/nosotros/saras"));
const Noticia = lazy(() => import("./pages/nosotros/noticias/Noticia"));
const NoticiaDetalle = lazy(() => import("./pages/nosotros/noticias/NoticiaDetalle"));

// Ahorros
const CuentaAhorrosPage = lazy(() => import("./pages/ahorros/cuentas-ahorros"));
const AhorroInversion = lazy(() => import("./pages/ahorros/ahorro-inversion"));
const AhorroJunior = lazy(() => import("./pages/ahorros/ahorro-junior"));
const AhorroProgramado = lazy(() => import("./pages/ahorros/ahorro-programado"));
const AhorroInclusion = lazy(() => import("./pages/ahorros/ahorro-inclusion"));
const AhorroInclusionJunior = lazy(() => import("./pages/ahorros/ahorro-inclusion-junior"));
const AhorroDual = lazy(() => import("./pages/ahorros/ahorro-dual"));
const AhorroCampo = lazy(() => import("./pages/ahorros/ahorro-campo"));

// Créditos
const CreditoConsumo = lazy(() => import("./pages/creditos/credito-consumo"));
const CreditoInmobiliario = lazy(() => import("./pages/creditos/credito-inmobiliario"));
const Microcredito = lazy(() => import("./pages/creditos/microcredito"));
const CreditoVioleta = lazy(() => import("./pages/creditos/credito-violeta/credito-violeta"));
const EcoFuturo = lazy(() => import("./pages/creditos/credito-eco-futuro/ecofuturo"));
const FutuNavideno = lazy(() => import("./pages/creditos/credito-futu-navideno/futu-navideno"));
const CreditoFutuAniversario = lazy(() => import("./pages/creditos/credito-futuaniversario/futuaniversario"));
const CreditoFutuConfianza = lazy(() => import("./pages/creditos/credito-futuconfianza/credito-futuconfianza"));
const CreditoPremium = lazy(() => import("./pages/creditos/credito-premium/credito-premium"));
const CreditoFutuSalud = lazy(() => import("./pages/creditos/credito-futusalud/credito-futusalud"));
const CreditoFutuAuto = lazy(() => import("./pages/creditos/credito-futuauto/credito-futuauto"));
const CreditoFutuUnido = lazy(() => import("./pages/creditos/credito-futu-unido/credito-futuunido"));
const CreditoFuturoSobreRuedas = lazy(() => import("./pages/creditos/credito-futu-sobre-ruedas/credito-futuro-sobre-ruedas"));
const CreditoFutuHogar = lazy(() => import("./pages/creditos/credito-futu-hogar/credito-futu-hogar"));
const CreditoAutoliquidable = lazy(() => import("./pages/creditos/credito-autoliquidable/credito-autoliquidable"));
const Convocatoria = lazy(() => import("./pages/creditos/convocatoria/convocatoria"));
const CreditoFutuPapa = lazy(() => import("./pages/creditos/credito-futu-papa/credito-futu-papa"));
const CreditoApoyoFuturo = lazy(() => import("./pages/creditos/credito-apoyo-futuro/credito-apoyo-futuro"));
const CreditoEmprendeFuturo = lazy(() => import("./pages/creditos/credito-emprende-futuro/credito-emprende-futuro"));

// Beneficios
const Peluqueria = lazy(() => import("./pages/beneficios/peluqueria"));
const Odontologia = lazy(() => import("./pages/beneficios/odontologia"));
const FondoMortuorio = lazy(() => import("./pages/beneficios/fondo-mortuorio"));
const MedicinaGeneral = lazy(() => import("./pages/beneficios/medicina-general"));
const CursosVacacionales = lazy(() => import("./pages/beneficios/cursos-vacacionales"));

// Inversiones
const DepositoPlazoFijo = lazy(() => import("./pages/inversiones/deposito-plazo-fijo"));

// En línea
const Horarios = lazy(() => import("./pages/enlinea/horarios"));
const Contactos = lazy(() => import("./pages/enlinea/contacto"));
const RecomiendayGana = lazy(() => import("./pages/enlinea/recomiendaygana"));
const QuejasYReclamos = lazy(() => import("./pages/enlinea/quejasyreclamos"));
const SeguimientoQuejasYReclamos = lazy(() => import("./pages/enlinea/seguimientoquejasreclamos"));
const FuturoTePremia = lazy(() => import("./pages/enlinea/futuroTePremia"));
const PasaporteAhorrista = lazy(() => import("./pages/enlinea/pasaporteAhorro"));
const GuardianesDelAhorro = lazy(() => import("./pages/enlinea/guardianesahorro"));

// Otros
const EducacionFinanciera = lazy(() => import("./pages/educacion-financiera"));
const LeyProteccionDatosEcuador = lazy(() => import("./pages/blog/ley-proteccion-datos-ecuador"));
const Maintenance = lazy(() => import("./pages/mantenimiento"));
const ValidationReport = lazy(() => import("./pages/validation-report"));
const JobOfferDetail = lazy(() => import("./pages/jobs/JobOfferDetail"));
const JobOfferList = lazy(() => import("./pages/jobs/JobOfferList"));

// Componente de carga mientras se cargan las páginas
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '50vh',
    fontSize: '1.2rem',
    color: '#666'
  }}>
    Cargando...
  </div>
);

function Layout() {
  const location = useLocation();

  // Rutas en las que no quiero mostrar el Navbar
  const hideNavbarRoutes = [/^\/verificaciondocumentos(\/.*)?$/];
  const shouldShowNavbar = !hideNavbarRoutes.some((regex) =>
    regex.test(location.pathname)
  );
  
  return (
    <>
      {shouldShowNavbar && <Navbar />}
      <Suspense fallback={<LoadingFallback />}>
        <Switch>
          <Route exact path="/" component={Index} />
          <Route exact path="/index" component={Index} />
          <Route exact path="/noticias" component={Noticia} />
          <Route
            exact
            path="/verificaciondocumentos/:codigo"
            component={ValidationReport}
          />
          {/* JOBS */}
          <Route path="/job-offersList" component={JobOfferList} />
          <Route path="/job-offers/:id" component={JobOfferDetail} />

          <Route
            exact
            path="/noticias/:categName/:categId/:noticeId"
            component={NoticiaDetalle}
          />
          <Route exact path="/saras" component={Saras} />
          <Route exact path="/quienes-somos" component={QuienesSomos} />
          <Route exact path="/resena-historica" component={ResenaHistorica} />
          <Route exact path="/cosede" component={Cosede} />
          <Route
            exact
            path="/informacion-financiera"
            component={InformacionFinanciera}
          />
          {/* <Route exact path="/gerencia" component={Gerencia} /> */}
          <Route exact path="/agencias" component={Agencias} />
          <Route
            exact
            path="/gobierno-corporativo"
            component={GobiernoCorporativo}
          />
          <Route exact path="/indicadores-genero" component={Indicadoresgenero} />
          <Route exact path="/codigo-etica" component={CodigoEtica} />
          {/**  Ahorros */}
          <Route exact path="/cuenta-ahorros" component={CuentaAhorrosPage} />
          <Route exact path="/ahorro-inversion" component={AhorroInversion} />
          <Route exact path="/ahorro-campo" component={AhorroCampo} />
          <Route exact path="/ahorro-junior" component={AhorroJunior} />
          <Route exact path="/ahorro-programado" component={AhorroProgramado} />
          <Route exact path="/ahorro-inclusion" component={AhorroInclusion} />
          <Route exact path="/ahorro-dual" component={AhorroDual} />
          <Route
            exact
            path="/ahorro-inclusion-junior"
            component={AhorroInclusionJunior}
          />
          {/**  Créditos */}
          <Route exact path="/credito-consumo" component={CreditoConsumo} />
          <Route
            exact
            path="/credito-inmobiliario"
            component={CreditoInmobiliario}
          />
          {/* MICROCREDITOS */}
          <Route exact path="/microcredito" component={Microcredito} />
          <Route
            exact
            path="/credito-futuconfianza"
            component={CreditoFutuConfianza}
          />
          <Route exact path="/credito-premium" component={CreditoPremium} />
          <Route exact path="/credito-futu-unido" component={CreditoFutuUnido} />
          <Route
            exact
            path="/credito-futuro-sobre-ruedas"
            component={CreditoFuturoSobreRuedas}
          />
          {/* <Route exact path="/emprende-futuro" component={EmprendeFuturo} /> */}
          <Route exact path="/credito-violeta" component={CreditoVioleta} />
          <Route exact path="/eco-futuro" component={EcoFuturo} />
          <Route exact path="/futu-navideno" component={FutuNavideno} />
          <Route exact path="/futu-salud" component={CreditoFutuSalud} />
          <Route exact path="/futu-auto" component={CreditoFutuAuto} />
          <Route exact path="/futu-hogar" component={CreditoFutuHogar} />
          <Route
            exact
            path="/credito-autoliquidable"
            component={CreditoAutoliquidable}
          />
          <Route exact path="/convocatoria" component={Convocatoria} />
          <Route
            exact
            path="/futu-aniversario"
            component={CreditoFutuAniversario}
          />
          <Route exact path="/futu-papa" component={CreditoFutuPapa} />
          <Route
            exact
            path="/apoyo-futuro"
            component={CreditoApoyoFuturo}
          />
          <Route
            exact
            path="/emprende-futuro"
            component={CreditoEmprendeFuturo}
          />
          {/** Beneficios */}
          <Route exact path="/peluqueria" component={Peluqueria} />
          <Route exact path="/odontologia" component={Odontologia} />
          <Route exact path="/medicina-general" component={MedicinaGeneral} />
          <Route exact path="/fondo-mortuorio" component={FondoMortuorio} />
          <Route
            exact
            path="/cursos-vacacionales"
            component={CursosVacacionales}
          />
          {/* Futuro te premia */}
          <Route exact path="/futuro-premia" component={FuturoTePremia} />
          {/* Galaxia del Ahorro */}
          <Route
            exact
            path="/guardianes-del-ahorro"
            component={GuardianesDelAhorro}
          />
          {/* Pasaporte del Ahorro */}
          <Route exact path="/pasaporte-ahorro" component={PasaporteAhorrista} />
          {/** Plazofijo */}
          <Route
            exact
            path="/deposito-plazo-fijo"
            component={DepositoPlazoFijo}
          />
          <Route exact path="/horarios" component={Horarios} />
          <Route exact path="/contactos" component={Contactos} />
          <Route
            exact
            path="/educacion-financiera"
            component={EducacionFinanciera}
          />
          {/* <Route exact path="/recomienda-y-gana" component={RecomiendayGana} /> */}
          <Route
            exact
            path="/ley-proteccion-datos"
            component={LeyProteccionDatosEcuador}
          />
          <Route
            exact
            path="/quejas-reclamos-sugerencias"
            component={QuejasYReclamos}
          />
          <Route
            exact
            path="/seguimiento-quejas-reclamos-sugerencias"
            component={SeguimientoQuejasYReclamos}
          />
          {/* Page Mantenimiento */}
          <Route exact path="/mantenimiento" component={Maintenance} />
        </Switch>
      </Suspense>
      {shouldShowNavbar && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter forceRefresh={true}>
      <Layout />
      {/**
         <GoogleReCaptchaProvider reCaptchaKey="6LdOXxApAAAAACZpjBgggvzLYoYJzj4_a4AXI9Lb" useRecaptchaNet="true"
          useEnterprise="true">
          <GoogleReCaptcha />
        </GoogleReCaptchaProvider>
         */}
    </BrowserRouter>
  );
}

export default App;
